import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const EssentialKit = loadable(() => import("./EssentialKit"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <EssentialKit {...props} />
  </ErrorBoundary>
);
